<template>
  <div>
    <Head class="noprint" :title="`${loan.borrower.fullname}`" />
    <div class="noprint flex items-center justify-between mb-8 w-full">
      <h1 class="moul flex items-center text-2xl">
        <Link class="flex items-center text-indigo-400 hover:text-indigo-600" href="/contacts"><CurrencyDollarIcon class="mr-2 w-8 h-8" /> កម្ចី</Link>
        <span class="text-indigo-400 font-medium"><ChevronRightIcon class="w-5 h-5" /></span>
        {{ loan.borrower.fullname }}
      </h1>
      <div class="flex">
        <button v-if="!loan.deleted_at" class="flex items-center px-4 py-2 text-white bg-gray-500 rounded-bl-md rounded-tl-md" tabindex="-1" type="button" @click="edit"><PencilSquareIcon class="mr-1 w-5 h-5" />កែតម្រូវ</button>
        <button v-if="!loan.deleted_at" class="flex items-center px-4 py-2 hover:text-indigo-500 text-white hover:bg-green-300 bg-green-500" tabindex="-1" type="button" @click="print"><PrinterIcon class="mr-1 w-5 h-5" />បោះពុម្ភ</button>
        <button v-if="!loan.deleted_at" class="flex items-center px-4 py-2 hover:text-indigo-500 text-white hover:bg-red-300 bg-red-500 rounded-br-md rounded-tr-md" tabindex="-1" type="button" @click="destroy"><TrashIcon class="mr-1 w-5 h-5" />លុបចេញ</button>
      </div>
    </div>
    <trashed-message v-if="loan.deleted_at" class="mb-6" @restore="restore"> កម្ចីនេះត្រូវបានលុបចេញពីកំណត់ត្រាហើយ! </trashed-message>
    <info-message v-if="loan.status == 2" class="mb-6"> អតិថិជនបានបង់ប្រាក់គ្រប់ចំនួន! </info-message>
    <div class="flex flex-wrap">
      <div class="printWidthFull w-full">
        <div class="nopaddingPrint p-4 bg-white overflow-hidden">
          <div class="brand flex flex-row items-center justify-center">
            <img src="/logo.png" alt="" class="logoPrint mr-2 w-20" />
            <div class="headline flex flex-col items-center">
              <p class="moul">{{ account.company_name_kh }}</p>
              <p>{{ account.company_name_en }}</p>
            </div>
          </div>
          <p class="text-center underline font-medium">កាលវិភាគទូទាត់</p>
          <div class="flex justify-between pb-1">
            <div class="left">
              <table>
                <tr>
                  <td class="pr-3 py-1">ឈ្មោះអតិថិជន:</td>
                  <td style="min-width: 180px; max-width: 220px" class="font-medium">{{ loan.borrower.fullname }}</td>
                </tr>
                <tr>
                  <td class="pr-3 py-1">លេខអតិថិជន:</td>
                  <td class="font-medium">{{ loan.borrower.customer_id }}</td>
                </tr>
                <tr>
                  <td class="pr-5 py-1">កាលបរិច្ឆេទអនុម័ត:</td>
                  <td class="font-medium">{{ formattedDate(loan.applied_date) }}</td>
                </tr>
                <tr>
                  <td class="pr-3 py-1">អត្រាការប្រាក់:</td>
                  <td class="font-medium">{{ loan.loan_type<2?"1.3":"1.5" }}%</td>
                  <!-- <td class="font-medium">{{ $loan_type<2?loan.interest_rate:"1.5" }}%</td> -->
                </tr>
                <tr>
                  <td class="pr-3 py-1">អាស័យដ្ឋាន:</td>
                  <td class="font-medium">{{ loan.borrower.fulladdress }}</td>
                </tr>
                <tr>
                  <td class="pr-3 py-1">លេខទូរស័ព្ទ:</td>
                  <td class="font-medium">{{ loan.borrower.phone }}</td>
                </tr>
              </table>
            </div>
            <div class="right">
              <table>
                <tr>
                  <td style="min-width: 160px" class="pr-3 py-1">ចំនួនទឹកប្រាក់:</td>
                  <td style="min-width: 170px" class="font-medium">{{ loan.amount }}</td>
                </tr>
                <tr>
                  <td class="pr-3 py-1">រយៈពេល:</td>
                  <td class="font-medium">{{ loan.term }}<span v-if="loan.term_period === '+1 week'"> សប្តាហ៍</span> <span v-else-if="loan.term_period === '+1 day'"> ថ្ងៃ</span> <span v-else-if="loan.term_period === '+2 weeks'">ដង (កន្លះខែម្តង)</span> <span v-else> ខែ</span></td>
                </tr>
                <tr>
                  <td class="pr-3 py-1">ថ្ងៃបង់ចុងក្រោយ:</td>
                  <td class="font-medium">{{ formattedDate(loan.latest_pay_date) }}</td>
                </tr>
                <tr>
                  <td class="pr-3 py-1">វគ្គខ្ចីលើកទី:</td>
                  <td class="font-medium">{{ loan.number_borrows }}</td>
                </tr>
                <tr>
                  <td class="pr-3 py-1">ឈ្មោះមន្ត្រីឥណទាន:</td>
                  <td class="font-medium">{{ loan.officer.fullname }}</td>
                </tr>
                <tr>
                  <td class="pr-3 py-1">លេខទូរស័ព្ទមន្ត្រីឥណទាន:</td>
                  <td class="font-medium">{{ loan.officer.phone }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="schedule">
            <table class="w-full">
              <tr class="font-medium">
                <td class="p-1 text-center border border-black">ល.រ</td>
                <td class="p-1 text-center border border-black">កាលបរិច្ឆេទបង់ប្រាក់</td>
                <td class="p-1 text-center border border-black">ប្រាក់ដើមនៅជំពាក់</td>
                <td class="p-1 text-center border border-black">ប្រាក់ដើមត្រូវសង</td>
                <td class="p-1 text-center border border-black">ការប្រាក់ត្រូវសង</td>
                <td class="p-1 py-1 text-center border border-black">សេវាកម្មប្រ/តិ<br />និងរដ្ឋបាល</td>
                <!-- <td class="p-1 text-center border border-black">ពិន័យ</td> -->
                <td class="p-1 py-1 text-center border border-black">សរុប</td>
              </tr>
              <tr>
                <td class="p-1 border border-black"></td>
                <td class="p-1 border border-black">{{ formattedDate(loan.applied_date) }}</td>
                <td class="p-1 border border-black"></td>
                <td class="p-1 border border-black"></td>
                <td class="p-1 border border-black"></td>
                <td class="p-1 border border-black"></td>
                <!-- <td class="p-1 text-center border border-black"></td> -->
                <td class="p-1 border border-black"></td>
              </tr>
              <!-- <tr :class="{ 'bg-green-100': schedule.can_pay_all, 'bg-red-100': isDateLaterThanToday(schedule.pay_date) && schedule.status == 0, 'bg-yellow-100': isDateLaterThanToday(schedule.pay_date) && schedule.status == 1 }" v-for="(schedule, index) in loan.schedules" :key="schedule.id"> -->
              <tr :class="{ 'bg-green-100': schedule.can_pay_all && Math.ceil(loan.term / 2) == index + 1 && schedule.status != 3, 'bg-red-100': isDateLaterThanToday(schedule.pay_date) && schedule.status == 0, 'bg-yellow-100': schedule.status == 1, 'bg-indigo-100': schedule.status == 2 }" v-for="(schedule, index) in loan.schedules" :key="schedule.id">
                <td class="p-1 border border-black">{{ index + 1 }}</td>
                <td class="p-1 border border-black">{{ formattedDate(schedule.pay_date) }}</td>
                <td class="p-1 text-right border border-black">{{ formatNumber(schedule.balance) }}</td>
                <td class="p-1 text-right border border-black">{{ formatNumber(schedule.principle_amount) }}</td>
                <td class="p-1 text-right border border-black">{{ formatNumber(schedule.interest) }}</td>
                <td class="p-1 text-right border border-black">{{ formatNumber(schedule.service_fee) }}</td>
                <!-- <td class="p-1 text-right border border-black">{{ isDateLaterThanToday(schedule.pay_date) ? formatNumber(schedule.penalty) : '' }}</td> -->
                <td class="p-1 text-right border border-black">
                  {{ formatNumber(schedule.amount_to_pay) }}
                  <p class="noprint text-red-500 text-sm font-medium" v-if="schedule.status == 3">បានបង់ផ្តាច់៖ {{ formatNumber(schedule.final_pay) }}</p>
                </td>
              </tr>
              <tr>
                <td class="p-1"></td>
                <td class="p-1"></td>
                <td class="p-1 text-right border border-black">0.00</td>
                <td class="p-1 text-right"></td>
                <td class="p-1 text-right border border-black">{{ formatNumber(loan.total_interest) }}</td>
                <td class="p-1 text-right border border-black">{{ formatNumber(loan.total_service_fee) }}</td>
                <!-- <td class="p-1 text-right"></td> -->
                <td class="p-1 text-right border border-black">{{ formatNumber(loan.total_payable) }}</td>
              </tr>
            </table>
          </div>
          <div class="note mb-4 pt-2">
            <p class="text-center text-sm px-12">{{ account.remarks }}</p>
          </div>
          <div class="signature pr-2">
            <div class="pb-3 text-right">ធ្វើនៅប៉ោយប៉ែត ថ្ងៃ {{ formattedDate(loan.applied_date) }}</div>
            <div class="pb-3 text-right">ស្នាមមេដៃស្តាំភាគី ខ</div>
            <div class="flex flex-wrap items-end justify-between">
              <div class="left text-center">
                <p class="pb-24">ហត្ថលេខាភាគី ក</p>
                <p class="font-medium">{{ account.representative_name }}</p>
              </div>
              <div class="middle text-center"></div>
              <div class="middle text-center">
                <p v-if="loan.guarantor" class="pb-24">អ្នកធានា{{ loan.guarantor_2 ? 'ទី១' : '' }}</p>
                <p v-if="loan.guarantor" class="font-medium">{{ loan.guarantor }}</p>
              </div>
              <div v-if="loan.guarantor_2" class="middle text-center">
                <p v-if="loan.guarantor_2" class="pb-24">អ្នកធានាទី២</p>
                <p v-if="loan.guarantor_2" class="font-medium">{{ loan.guarantor_2 }}</p>
              </div>
              <div class="right text-center">
                <p class="pb-24">អ្នកខ្ចី</p>
                <p class="font-medium">{{ loan.borrower.fullname }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="noprint mt-2 p-6 w-full bg-white">
        <p class="pb-4 font-medium">កំណត់ចំណាំ៖ <span class="text-green-500">{{ loan.loan_type<2 ? 'បង់ថយ' : 'បង់ថេរ' }}</span></p>
        <p v-if="loan.remarks" class="pb-4">*** {{ loan.remarks }}</p>
        <table>
          <tr>
            <td class="pr-4"><div class="w-10 h-4 bg-red-100 border"></div></td>
            <td>យឺត</td>
          </tr>
          <tr>
            <td class="pr-4"><div class="w-10 h-4 bg-yellow-100 border"></div></td>
            <td>បង់មិនទាន់គ្រប់</td>
          </tr>
          <tr>
            <td class="pr-4"><div class="w-10 h-4 bg-indigo-100 border"></div></td>
            <td>បានបង់រួចរាល់</td>
          </tr>
          <tr>
            <td class="pr-4"><div class="w-10 h-4 bg-green-100 border"></div></td>
            <td>អាចបង់ផ្តាច់បាន</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import InfoMessage from '@/Shared/InfoMessage'
import { CurrencyDollarIcon, ChevronRightIcon, PrinterIcon, TrashIcon, PencilSquareIcon } from '@heroicons/vue/24/outline'
import { formattedDate, formatNumber, isDateLaterThanToday } from '@/helper'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    TrashedMessage,
    InfoMessage,
    CurrencyDollarIcon,
    ChevronRightIcon,
    PrinterIcon,
    PencilSquareIcon,
    TrashIcon,
  },
  layout: Layout,
  props: {
    loan: Object,
    account: Object,
  },
  remember: 'form',
  data() {
    return {
      account: this.account,
      form: this.$inertia.form({
        // customer_id: this.contact.customer_id,
        borrower_fullname: this.loan.borrower.fullname,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/contacts/${this.loan.id}`)
    },
    destroy() {
      if (confirm('តើអ្នកពិតជាចង់លុបកម្ចីចេញមែនទេ?')) {
        this.$inertia.delete(`/loans/${this.loan.id}`)
      }
    },
    edit() {
      if (confirm('តើអ្នកពិតជាចង់កែតម្រូវកម្ចីនេះមែនទេ?')) {
        this.$inertia.visit(`/loans/${this.loan.id}/edit`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this contact?')) {
        this.$inertia.put(`/contacts/${this.loan.id}/restore`)
      }
    },
    print() {
      var style = document.createElement('style')
      style.appendChild(document.createTextNode('@media print { @page { size: portrait; } }'))
      document.head.appendChild(style)
      window.print()
    },
    formattedDate,
    formatNumber,
    isDateLaterThanToday,
  },
}
</script>
